import React, { useEffect, useRef } from 'react';
import { MorphologyStore } from '../MorphologyStore';
import { clearWord, ConfirmationTypes, maybeConfirmAndProceed } from '../morphologyUtils';
import RevealConfirmationDialogCluster from './RevealConfirmationDialogCluster';

const DesktopToolbar = () => {
  const { autocheckOn, completed, toolbar: { clearIsOpen, revealIsOpen, checkIsOpen } }
    = MorphologyStore.useState();
  const ref = useRef<any>(null);

  // If a click is outside the toolbar, it closes all menus.
  // A click within the menu is handled by togglesMenus, which closes all but the clicked one.
  useEffect(() => {
    const onClickOutside = (e: any) => {
      if (ref.current && !ref.current.contains(e.target)) {
        MorphologyStore.update(s => {
          s.toolbar.clearIsOpen = false;
          s.toolbar.revealIsOpen = false;
          s.toolbar.checkIsOpen = false;
        });
        document.removeEventListener('click', onClickOutside);
      }
    };
    if (clearIsOpen || revealIsOpen || checkIsOpen) {
      document.addEventListener('click', onClickOutside);
    }
    return () => {
      document.removeEventListener('click', onClickOutside);
    };
  }, [clearIsOpen, revealIsOpen, checkIsOpen]);

  const toggleMenus = (index: number) => {
    switch (index) {
      case 1:
        MorphologyStore.update(s => {
          s.toolbar.clearIsOpen = !clearIsOpen;
          s.toolbar.revealIsOpen = false;
          s.toolbar.checkIsOpen = false;
        });
        break;
      case 2:
        MorphologyStore.update(s => {
          s.toolbar.clearIsOpen = false;
          s.toolbar.revealIsOpen = !revealIsOpen;
          s.toolbar.checkIsOpen = false;
        });
        break;
      case 3:
        MorphologyStore.update(s => {
          s.toolbar.clearIsOpen = false;
          s.toolbar.revealIsOpen = false;
          s.toolbar.checkIsOpen = !checkIsOpen;
        });
        break;
    }
  };

  return (
    <div ref={ref} className="morphologyToolbar">
      <RevealConfirmationDialogCluster/>
      <div className="dropdownButton" onClick={() => toggleMenus(1)}>
        <div className="buttonLabel">Clear</div>
        <ul className={`dropdownMenu clearMenu ${clearIsOpen ? 'open' : ''}`}>
          <li onClick={clearWord}>Word</li>
          <li onClick={() => {
            if (completed) return;
            MorphologyStore.update(s => { s.toolbar.confirmationDialog.clearAllIsOpen = true; });
          }}>Puzzle</li>
        </ul>
      </div>
      <div className="dropdownButton" onClick={() => toggleMenus(2)}>
        <div className="buttonLabel">Reveal</div>
        <ul className={`dropdownMenu revealMenu ${revealIsOpen ? 'open' : ''}`}>
          <li onClick={() => {
            maybeConfirmAndProceed(ConfirmationTypes.RevealLetter);
          }}>Square</li>
          <li onClick={() => {
            maybeConfirmAndProceed(ConfirmationTypes.RevealWord);
          }}>Word</li>
          <li onClick={() => {
            maybeConfirmAndProceed(ConfirmationTypes.RevealPuzzle);
          }}>Puzzle</li>
        </ul>
      </div>
      <div className="dropdownButton" onClick={() => toggleMenus(3)}>
        <div className={autocheckOn ? 'autocheck buttonLabel' : 'buttonLabel' }>
          { autocheckOn ? 'Autocheck' : 'Check' }
        </div>
        <ul className={`dropdownMenu checkMenu ${checkIsOpen ? 'open' : ''}`}>
          <li onClick={() => {
            maybeConfirmAndProceed(ConfirmationTypes.Autocheck);
          }}>Autocheck</li>
          <li className={autocheckOn ? 'disabled' : ''} onClick={() => {
            maybeConfirmAndProceed(ConfirmationTypes.CheckLetter);
          }}>Square</li>
          <li className={autocheckOn ? 'disabled' : ''} onClick={() => {
            maybeConfirmAndProceed(ConfirmationTypes.CheckWord);
          }}>Word</li>
          <li className={autocheckOn ? 'disabled' : ''} onClick={() => {
            maybeConfirmAndProceed(ConfirmationTypes.CheckPuzzle);
          }}>Puzzle</li>
        </ul>
      </div>
    </div>
  );
};

export default DesktopToolbar;